import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, styled, Button } from '@mui/material';
import { QRCodeSVG } from 'qrcode.react';
import CloseIcon from '@mui/icons-material/Close';
const Title = styled(Typography)(props => ({
  color: "white",
  textAlign: "center",
  fontFamily: "'Inter', sans-serif",
  fontSize: "22px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "normal"
}));
const Content = styled(Typography)(props => ({
  color: "white",
  width: "100%",
  textAlign: "start",
  fontFamily: "'Inter', sans-serif",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "normal"
}));
function XrGoodDeviceError(props) {
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      position: 'absolute',
      top: '0',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#282828e0',
      transition: 'opacity 1s',
      opacity: '1',
      zIndex: '700',
      gap: "40px",
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      fontWeight: 600,
      zIndex: "1000"
    }
  }, /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: 'column',
      gap: "30px"
    }
  }, /*#__PURE__*/React.createElement(Title, null, "Scan QR Code with AR Compatible Device"), /*#__PURE__*/React.createElement(Box, {
    sx: {
      display: "flex",
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      gap: "10px"
    }
  }, /*#__PURE__*/React.createElement(Content, null, "1. Open camera on your smartphone or tablet"), /*#__PURE__*/React.createElement(Content, null, "2. Scan QR Code with your smartphone or tablet"), /*#__PURE__*/React.createElement(Content, null, "3. Click to open code link on your device"))), /*#__PURE__*/React.createElement(Box, {
    sx: {
      padding: '10px',
      backgroundColor: "white"
    }
  }, /*#__PURE__*/React.createElement(QRCodeSVG, {
    size: 200,
    value: window.location.href
  })), /*#__PURE__*/React.createElement(CloseIcon, {
    onClick: props.onClose,
    sx: {
      position: 'fixed',
      right: "0",
      top: "0",
      margin: "20px",
      width: "30px",
      height: "30px",
      color: "#7F7F7F",
      cursor: "pointer",
      border: "2px solid #7F7F7F",
      padding: "3px",
      borderRadius: "100px",
      transitionProperty: "transform",
      transitionDuration: " 0.2s",
      '&:hover': {
        transform: "scale(1.1)"
      }
    }
  }));
}
export default XrGoodDeviceError;